export type Feature = {
  title: string
  body: string
}

export const crmFeatures: Feature[] = [
  {
    title: 'Contacts',
    body: 'Every lead and customer in one place, searchable. The guy who called in March is still there when he calls again in October.',
  },
  {
    title: 'Pipelines',
    body: 'See exactly where every job sits: new lead, estimate sent, scheduled, done. Nothing quietly stalls at the estimate stage.',
  },
  {
    title: 'Invoicing',
    body: 'Send invoices and get paid from the same place the lead came in, synced to QuickBooks so your books stay right.',
  },
  {
    title: 'Dashboard',
    body: 'Your real numbers at a glance: what came in, what got booked, what is still open.',
  },
]

export const automations: Feature[] = [
  {
    title: 'Follow-ups',
    body: 'A lead that goes quiet gets chased on its own until they book or say no.',
  },
  {
    title: 'Reminders',
    body: 'Customers get reminded before the appointment, so you stop driving out to empty driveways.',
  },
  {
    title: 'Review requests',
    body: 'The ask goes out after the job is done, while they still remember how it went.',
  },
]

export const marketing: Feature[] = [
  {
    title: 'Social posting',
    body: 'Posts go out on a schedule so your page does not look abandoned when someone checks you out.',
  },
  {
    title: 'Email campaigns',
    body: 'Stay in front of past customers and win the repeat work you already earned once.',
  },
]

export const onboardingSteps: Feature[] = [
  {
    title: 'We get on a call',
    body: 'We go through how your leads come in today and what is falling through.',
  },
  {
    title: 'We build it with you',
    body: 'Your receptionist and your workflows get set up on the call, in your words, for your services.',
  },
  {
    title: 'We show you how to use it',
    body: 'You get walked through the tools until you can run them without us. Most clients are live in about a week.',
  },
]
